var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":"https://www.private-only.cc/frrrz/wp-content/themes/TheAgency-V2-3/landing/media/logo-01.png"}}),_c('HelloWorld',{attrs:{"msg":"Willkommen im Room-Manager"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }